<table mat-table [dataSource]="tableDataSource" class="table table-hover" id="genericTable">
    @for (disCol of displayedColumns; track disCol; let colIndex = $index) {
        <ng-container matColumnDef="{{ disCol }}">
            @if (disCol && getColumnOption(disCol); as col) {
                <th
                    (click)="sort(col)"
                    mat-header-cell
                    *matHeaderCellDef
                    [ngClass]="col.headerCellClass"
                    [ngStyle]="col.headerCellStyle"
                    [style.cursor]="col.sortable ? 'pointer' : 'auto'"
                >
                    {{ col.name }}
                    @if (orderBy != null && col.field === orderBy.field) {
                        <span
                            class="glyphicon"
                            [ngClass]="{
                                'glyphicon-chevron-up': orderBy.order === SortOrder.Ascending,
                                'glyphicon-chevron-down': orderBy.order === SortOrder.Descending,
                            }"
                        ></span>
                    }
                </th>
                <td
                    mat-cell
                    *matCellDef="let d"
                    [ngClass]="col.format && isNowrap(col.format) ? 'nowrap-cell ' + col.cellClass : col.cellClass"
                    [ngStyle]="col.cellStyle"
                    class="fixed-height"
                >
                    @if (col.action == null) {
                        {{ col.field && d[col.field] | cellFormat: col.format }}
                    } @else {
                        @if (!col.askConfirmation) {
                            @if ((!col.hideField || !d[col.hideField]) && ((col.hideFunction != null && !col.hideFunction(d)) || col.hideFunction == null)) {
                                <a (click)="col.action(d)" class="a-link">{{ col.field && d[col.field] }}</a>
                            }
                        } @else {
                            @if ((!col.hideField || !d[col.hideField]) && ((col.hideFunction != null && !col.hideFunction(d)) || col.hideFunction == null)) {
                                <a
                                    class="a-link"
                                    mwlConfirmationPopover
                                    [popoverTitle]="col.confirmationTitle"
                                    [popoverMessage]="col.confirmationMessage"
                                    placement="left"
                                    (cancel)="onCancel()"
                                    (confirm)="col.action(d)"
                                >
                                    {{ col.field && d[col.field] }}
                                </a>
                            }
                        }
                    }
                </td>
            }
        </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<div [class.hidden]="!tableDataSource || (tableDataSource && tableDataSource.data.length === 0)">
    @if (showPagination) {
        <mat-paginator [pageSizeOptions]="[25, 50]" [pageSize]="pageSize" [length]="totalRecords" showFirstLastButtons #pager (page)="pageChange($event)"></mat-paginator>
    }
</div>
